import $ from 'jquery';

export default function initSocialLinksCardComponent() {
    var $socialLinksCardElement = $('section.n-section.n-social-links-card');
    var $previousSectionElement = $socialLinksCardElement.prev('section.n-section');
    var $previousCardSectionPlaceElement = $previousSectionElement.children().last();

    if (
        $previousCardSectionPlaceElement.hasClass('n-card-section')
        && !$previousCardSectionPlaceElement.hasClass('n-reverse')
    ) {
        $socialLinksCardElement.find('.n-card-section').addClass('n-reverse');
    }
}
